import { useState, useRef } from "react";
import Cropper from "react-easy-crop";
import trashIcon from "../assets/biodata/img/trash-icon.svg";
import cameraIcon from "../assets/biodata/img/camera_icon.png";

export default function BiodataForm({
  sections,
  setSections,
  userImage,
  setUserImage,
  onReset,
}) {
  const fileInputRef = useRef(null);

  const [showCropper, setShowCropper] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onSelectFile = (e) => {
    if (!e.target.files || !e.target.files.length) return;

    const reader = new FileReader();
    reader.onload = () => {
      setUserImage(reader.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return canvas.toDataURL("image/png");
  };

  const saveCroppedImage = async () => {
    if (!croppedAreaPixels || !userImage) return;

    const croppedImg = await getCroppedImg(
      userImage,
      croppedAreaPixels
    );

    localStorage.setItem("bdm_user_image", croppedImg);
    setUserImage(croppedImg);
    setShowCropper(false);
  };

  const deleteImage = () => {
    localStorage.removeItem("bdm_user_image");
    setUserImage(null);
  };

  const resetForm = () => {
    onReset();
    setShowCropper(false);
  };

  const moveSection = (i, dir) => {
    setSections((prev) => {
      const updated = [...prev];
      const t = dir === "up" ? i - 1 : i + 1;
      if (t < 0 || t >= updated.length) return prev;

      [updated[i], updated[t]] = [updated[t], updated[i]];
      return updated;
    });
  };

  const moveField = (si, fi, dir) => {
    setSections((prev) =>
      prev.map((section, index) => {
        if (index !== si) return section;

        const fields = [...section.fields];
        const t = dir === "up" ? fi - 1 : fi + 1;
        if (t < 0 || t >= fields.length) return section;

        [fields[fi], fields[t]] = [fields[t], fields[fi]];
        return { ...section, fields };
      })
    );
  };

  const updateTitle = (i, val) => {
    setSections((prev) =>
      prev.map((section, index) =>
        index === i ? { ...section, title: val } : section
      )
    );
  };

  const updateField = (si, fi, key, val) => {
    setSections((prev) =>
      prev.map((section, sIndex) =>
        sIndex === si
          ? {
              ...section,
              fields: section.fields.map((field, fIndex) =>
                fIndex === fi ? { ...field, [key]: val } : field
              ),
            }
          : section
      )
    );
  };

  const addSection = () => {
    setSections((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        title: "ಇತರೆ ವಿವರಗಳು",
        fields: [
          {
            id: crypto.randomUUID(),
            label: "ಫೀಲ್ಡ್ ಹೆಸರು",
            placeholder: "ಫೀಲ್ಡ್ ಹೆಸರು ನಮೂದಿಸು",
            value: "",
          },
        ],
      },
    ]);
  };

  const addField = (si) => {
    setSections((prev) =>
      prev.map((section, index) =>
        index === si
          ? {
              ...section,
              fields: [
                ...section.fields,
                {
                  id: crypto.randomUUID(),
                  label: "ಫೀಲ್ಡ್ ಹೆಸರು",
                  placeholder: "ಫೀಲ್ಡ್ ಹೆಸರು ನಮೂದಿಸು",
                  value: "",
                },
              ],
            }
          : section
      )
    );
  };

  const removeSection = (si) => {
    setSections((prev) => prev.filter((_, index) => index !== si));
  };

  const removeField = (si, fi) => {
    setSections((prev) => {
      const updated = [...prev];
      updated[si].fields = updated[si].fields.filter(
        (_, index) => index !== fi
      );
      return updated;
    });
  };

  return (
    <>

      {/* USER IMAGE */}
      <div className="bdm_panel bd_intro_sect rounded-lg mb-2 shadow-sm">
        <h2>Marriage Biodata Maker Online (Free)</h2>
        <p>
        Our free marriage biodata maker helps you create a professional wedding biodata 
        for matchmaking. This tool is suitable for boys and girls and supports multiple 
        languages and formats.
        </p>
        <p>
        <strong>Create marriage biodata in: </strong> 
        Hindi, English, Marathi, Gujarati, Tamil , Telugu
        </p>
      </div>

      <div className="bdm_lang_sect rounded-lg mb-2 shadow-sm">
        <div className="bdm_user_pic">
          <span className="bdm_user_img">
            <img src={userImage || cameraIcon} alt="User" />
          </span>

          <div className="bdm_u_btn">
            <button
              className="btn btn-sm btn-primary uploadbtn"
              onClick={() => fileInputRef.current.click()}
            >
              Upload Photo
            </button>

            {userImage && (
              <button
                className="btn btn-sm btn-outline-grey deletebtn"
                onClick={deleteImage}
              >
                Delete
              </button>
            )}

            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={onSelectFile}
            />
          </div>
        </div>
         <div className="bdm_u_lang_choose">

  <span>Language</span>
<select
  className="form-select"
  value="https://telugu.webdunia.com/biodata-maker"
  onChange={(e) => {
    const url = e.target.value;
    if (url) window.open(url, "_blank");
  }}
>
    <option value="https://telugu.webdunia.com/biodata-maker" selected>తెలుగు</option>
    <option value="https://english.webdunia.com/biodata-maker" >English</option>
    <option value="https://gujarati.webdunia.com/biodata-maker">ગુજરાતી</option>
    <option value="https://hindi.webdunia.com/biodata-maker" >हिन्दी</option>
    <option value="https://marathi.webdunia.com/biodata-maker">मराठी</option>
    <option value="https://tamil.webdunia.com/biodata-maker">தமிழ்</option>
  </select>
</div>
      </div>
    <div className="form_statcky">
      {/* SECTIONS */}
      {sections.map((section, si) => (
        <div className="bdm_panel mb-3 shadow-sm" key={section.id}>
          <div className="bdm_field_row first-row">
            <input
              value={section.title}
              onChange={(e) => updateTitle(si, e.target.value)}
              className="form-control bg_form_control no-border" 
            />
          </div>

          {section.fields.map((field, fi) => (
            <div className="bdm_field_row" key={field.id}>
              <div className="bdm_field_col1">
              <input
                value={field.label}
                onChange={(e) =>
                  updateField(si, fi, "label", e.target.value)
                }
                className="form-control bg_form_control bio_form"  
              />

              <input
                placeholder={field.placeholder}
                value={field.value}
                onChange={(e) =>
                  updateField(si, fi, "value", e.target.value)
                }
                className="form-control bio_form"  
              />
            </div>

            <div className="bdm_field_col2">
              <div className="bdm_up_down_b">
             <button onClick={() => moveField(si, fi, "up")} disabled={fi === 0} className="btn btn-md btn-outline-primary btn_up_down" title="Move Up"> ↑</button>
             <button onClick={() => moveField(si, fi, "down")} disabled={fi === section.fields.length - 1} className="btn btn-md btn-outline-primary btn_up_down" title="Move Down">↓</button>
              </div>
              <button
                className="bdm_trash_icon remove"
                onClick={() => removeField(si, fi)}
              >
                <img src={trashIcon} alt="delete" />
              </button>
            </div>
            </div>
          ))}

          <div className="bdm_panel_foot d-flex gap-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => addField(si)}
            >
              Add Field
            </button>

            <button
              className="btn btn-sm btn-outline-grey mx-2"
              onClick={() => removeSection(si)}
            >
              Remove Section
            </button>

            {si > 0 && (
              <button
                onClick={() => moveSection(si, "up")}
                className="btn btn-sm btn-outline-primary btn_up_down"
              >
                ↑
              </button>
            )}

            {si < sections.length - 1 && (
              <button
                onClick={() => moveSection(si, "down")}
                className="btn btn-sm btn-outline-primary btn_up_down mx-2"
              >
                ↓
              </button>
            )}
          </div>
        </div>
      ))}
      </div>

      {/* FOOTER */}
      <div className="bg-white p-3 mt-2 text-center shadow-sm d-flex justify-content-between gap-2 rounded-lg mx-auto">
        <button
          className="btn btn-md btn-outline-primary"
          onClick={addSection}
        >
          Add Section
        </button>

        <button
          className="btn btn-md btn-outline-grey"
          onClick={resetForm}
        >
          Reset Form
        </button>
      </div>

      {/* CROPPER */}
      {showCropper && (
        <div className="cropper-overlay">
          <div className="cropper-box">
            <div className="cropper-area">
              <Cropper
                image={userImage}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={(c, pixels) =>
                  setCroppedAreaPixels(pixels)
                }
              />
            </div>

            <div className="cropper-actions">
              <button
                className="btn btn-primary"
                onClick={saveCroppedImage}
              >
                Save
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowCropper(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
